import React from 'react';
import { StudentProvider } from './StudentContext';
import AppHeader from './AppHeader';
import BottomNav from './BottomNav';
import ProfileSheet from './ProfileSheet';
import './StudentShell.css';

/**
 * The student application shell — ONE mobile product frame for every student screen:
 * app bar on top, content, bottom navigation. (Full-screen exams intentionally sit outside it.)
 * Replaces the old hamburger navbar + left sidebar for students.
 */
export default function StudentShell({ children }) {
  return (
    <StudentProvider>
      <div className="z-shell">
        <a className="z-skip-link" href="#z-main">Skip to content</a>
        <AppHeader />
        <main id="z-main" className="z-shell-main" tabIndex={-1}>{children}</main>
        <BottomNav />
        <ProfileSheet />
      </div>
    </StudentProvider>
  );
}
